import { SKETCH_WEBSITE } from '@sketch/env-config'

export const CANVAS_VIEW_DOCS = `${SKETCH_WEBSITE}/docs/canvas-view`
